module.exports = __webpack_public_path__ + "static/media/29ADMSPC1.bc049c0e.jpg";